
export const calendar = {
  'calendar.globalCalendar': 'Global Calendar',
  'calendar.globalDescription': 'View and manage all deadlines and events across your farms',
  'calendar.view': 'View',
  'calendar.month': 'Month',
  'calendar.week': 'Week',
  'calendar.agenda': 'Agenda',
  'calendar.farms': 'Farms',
  'calendar.subsidyPrograms': 'Subsidy Programs',
  'calendar.regulationTypes': 'Regulation Types',
  'calendar.eventTypes': 'Event Types',
  'calendar.eventDetails': 'Event Details',
  'calendar.farm': 'Farm',
  'calendar.viewFarm': 'View Farm Profile',
  'calendar.subsidyProgram': 'Subsidy Program',
  'calendar.regulationType': 'Regulation Type',
  'calendar.description': 'Description',
  'calendar.farmCalendar': 'Farm Calendar',
  'calendar.emailReminders': 'Email reminders will be sent 7 days before each deadline to the farm contact.'
} as const;
